<script>
  /**
   * HydroLists — renders hydrograph lists per river using `uniqueRivers`.
   *
   * @module HydroLists
   * @prop {Object} gaugeConfig - Gauge configuration object.
   * @prop {number} group - Display mode (1 = default, 2 = scaled to flood categories).
   * @prop {Object<string, Array<Object>>} uniqueRivers - Map of river name => array of waterbody objects.
   *
   * @description
   * Each river entry lists hydrographs for its waterbodies. When available, images are used
   * as placeholders for the hydrograph component. The `attachHydrographComponent` action
   * (documented inline) can be used to mount the full hydrograph app into the DOM.
   */
  export let gaugeConfig // TODO: This is doing nothing and is a default empty config? TM
  export let group
  export let uniqueRivers
  var i = 1

  /**
   * This function runs when the hydrograph-app div is initiated. It
   * loads the Hydrograph component into this separate Svelte component.
   *
   * @param {DOM Element} hydrographElement A reference to the DOM element.
   * @returns {Function} The callback for when the hydrographElement is removed from the DOM.
   */
  const attachHydrographComponent = (node, [lid, floodscale = false]) => {
    if (hydrographAppOptions != null) {
      // Make the target a reference to our hydrographElement DOM element
      hydrographAppOptions['options']['target'] = node
      hydrographAppOptions['options']['props']['lid'] = lid
      hydrographAppOptions['options']['props']['chartName'] = 'official' // we are only using hydrograph chart
      hydrographAppOptions['options']['props']['view'] = 'area'
      hydrographAppOptions['options']['props']['scaleflood'] = floodscale

      // Initiate the hydrograph app like we would in gauge.html
      // This uses options that were passed down from gauge.html (lid, configuration, ratings, assetURL)
      var hydrographApp = new hydrographAppOptions['app'](hydrographAppOptions['options'])
    }

    // Called when the hydrograph-app is destroyed
    const onDestroy = function () {}

    return onDestroy
  }
</script>

<div class="uk-width-1-1 uk-width-1-1@m">
  <table id="hydrolists">
    <tbody>
      {#each Object.keys(uniqueRivers).sort() as river, i}
        <tr>
          <td class="riverlinks">
            <div>
              <div name="river{i}" id="river{i}" title={river} href="#">{river}</div>
            </div>
            <ul>
              {#each uniqueRivers[river].sort() as lid}
                {#if gaugeConfig.inService.enabled == false}
                  <div class="uk-position-center">Gauge {lid.id} out of service.</div>
                {:else if group === 1}
                  <!-- Default Hydrograph //-->
                  <li class="hydrographs">Default Hydrograph: {lid.id}</li>
                  <!-- <li class="chart"><div use:attachHydrographComponent={[lid.id, false]} /></li> -->
                  <li class="chart">
                    <img
                      src={`/resources/hydrographs/${lid.id.toLowerCase()}_hg.png`}
                      alt={`${lid.id} default hydrograph`} />
                  </li>
                {:else}
                  <!-- Scaled To Flood Category Hydrograph //-->
                  <li class="hydrographs">Scaled To Flood Category: {lid.id}</li>
                  <!-- <li class="chart"><div use:attachHydrographComponent={[lid.id, true]} /></li> -->
                  <li class="chart">
                    <img
                      src={`/resources/hydrographs/${lid.id.toLowerCase()}_record.png`}
                      alt={`${lid.id} hydrograph scaled to flood category`} />
                  </li>
                {/if}
              {/each}
              <li class="toplink"><a href="#top">Top</a></li>
            </ul>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<style>
  #hydrolists {
    width: 100%;
  }

  .riverlinks {
    border: 0;
    max-width: 300px;
    height: 125px;
    border-bottom: 1.5px solid #ff8c00;
  }
  li.hydrographs {
    list-style-type: none;
    font-weight: bold;
  }
  .toplink {
    list-style-type: none;
    font-size: 10.5px;
    text-align: right;
  }

  a:hover {
    text-decoration: none;
  }

  li.chart {
    list-style-type: none;
  }
</style>
